import {Injectable} from '@angular/core';
import {ReplaySubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HideHeaderService {

  hideHeaderService$: Subject<boolean> = new ReplaySubject(1)

}
